import type { DocumentStatus, ShortDocument, YscDocument } from '@yescapa-dev/ysc-api-js/legacy'
import { Constants } from '@yescapa-dev/ysc-api-js/legacy'

export const everyDocumentIsUploaded = (documents: (ShortDocument | YscDocument)[]) => {
  const documentUploadedStatuses: Partial<DocumentStatus>[] = [Constants.DOCUMENTS.STATUS.VALIDATION_ASKED, Constants.DOCUMENTS.STATUS.VALIDATED, Constants.DOCUMENTS.STATUS.NEEDDOC]
  return !!documents.length && documents.every(({ status }) => documentUploadedStatuses.includes(status))
}
